module.exports = __webpack_public_path__ + "assets/img/banner-ph.fc6e5950.webp";